module.exports = {
      id: "ai-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#ai",
      toString: function () {
        return this.url;
      }
    }